// extracted by mini-css-extract-plugin
export var divider = "_u9-0";
export var systemMessage = "_u9-1";